import type { RouteRecordRaw } from 'vue-router';
import LoginPage1 from '@/views/authentication/auth1/LoginPage1.vue';
import AuthLogin from '@/views/authentication/authForms/AuthLogin.vue';
import EmailConfirmation from '@/views/authentication/authForms/EmailConfirmation.vue';

const AuthRoutes = {
  path: '/auth',
  component: () => import('@/layouts/blank/BlankLayout.vue'),
  meta: {
    requiresAuth: false
  },
  children: [
    {
      name: 'Login',
      path: '/auth/login',
      component: LoginPage1,
      meta: {
        layout: 'blank',
        title: 'Login'
      }
    },
    {
      name: 'Forgot Password',
      path: '/auth/forgot-password',
      component: LoginPage1,
      meta: {
        layout: 'blank',
        title: 'Forgot Password'
      }
    },
    {
      name: 'Reset Password',
      path: '/auth/reset-password',
      component: () => import('@/views/authentication/auth1/ResetPwd1.vue')
    },
    {
      name: 'Email Confirmation',
      path: '/auth/email-confirmation',
      component: EmailConfirmation,
      meta: {
        layout: 'blank',
        title: 'Email Confirmation'
      }
    },
    {
      name: 'Error 404',
      path: '/pages/error',
      component: () => import('@/views/pages/maintenance/error/Error404Page.vue')
    }
  ]
};

export default AuthRoutes;
